<!-- my-component.vue -->
<template>
<!-- Button trigger modal -->

<div class="landin-1-api">
    <div class="row" style="position:absolute;z-index:6;width:100vw;margin-left:0px;padding-left:10px;text-align:center;">
        <div class="col-12 col-md-12 text-landing-1">
            <h1 class="title-landing">Pay only for what you need.</h1>
        </div>
        <div class="hidden-xs hidden-md"></div>
        <div class="co-12 col-md-3">
          <div class="card-price">
            <div class="row price-section" >
              <div class="col-12 col-md-12">
                <h1 class="title-price-section">UI / UX Mockup</h1>
              </div>
              <div class="col-12 col-md-12">
                <t class="from-sign">From&nbsp;&nbsp;</t><t class="dollar-sign">$</t><t class="price-number">&nbsp;300</t>
              </div>
              <div class="col-12 hidden-md">
                <button class="quote-button" v-on:click='data_to_app'>Request a plan</button>
              </div>
              <div class="hidden-xs col-md-12">
                <button class="quote-button" v-on:click='data_to_app_web'>Request a plan</button>
              </div>
            </div>
            <div class="row ligne-tick">
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Sketch mockup
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Logo Making
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;UI / IX Interface
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Mockup Video
              </div>
            </div>
          </div>
        </div>
        <div class="co-12 col-md-3">
          <div class="card-price">
            <div class="row price-section" >
              <div class="col-12 col-md-12">
                <h1 class="title-price-section">Simple Website</h1>
              </div>
              <div class="col-12 col-md-12">
                <t class="from-sign">From&nbsp;&nbsp;</t><t class="dollar-sign">$</t><t class="price-number">&nbsp;1,000</t>
              </div>
              <div class="col-12 hidden-md">
                <button class="quote-button" v-on:click='data_to_app'>Request a plan</button>
              </div>
              <div class="hidden-xs col-md-12">
                <button class="quote-button" v-on:click='data_to_app_web'>Request a plan</button>
              </div>
            </div>
            <div class="row ligne-tick">
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Hot page reload
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Responsive design
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;UI / IX Interface
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Admin Dashboards
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;SEO
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Analytics
              </div>
            </div>
          </div>
        </div>
        <div class="co-12 col-md-3">
          <div class="card-price">
            <div class="row price-section" >
              <div class="col-12 col-md-12">
                <h1 class="title-price-section">Web App</h1>
              </div>
              <div class="col-12 col-md-12">
                <t class="from-sign">From&nbsp;&nbsp;</t><t class="dollar-sign">$</t><t class="price-number">&nbsp;3,000</t>
              </div>
              <div class="col-12 hidden-md">
                <button class="quote-button" v-on:click='data_to_app'>Request a plan</button>
              </div>
              <div class="hidden-xs col-md-12">
                <button class="quote-button" v-on:click='data_to_app_web'>Request a plan</button>
              </div>
            </div>
            <div class="row ligne-tick">
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Hot page reload
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Responsive design
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;UI / IX Interface
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Admin Dashboards
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;SEO
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Analytics
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Real-time Database
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;User Connection
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Complex features
              </div>
            </div>
          </div>
        </div>
        <div class="co-12 col-md-3">
          <div class="card-price">
            <div class="row price-section" >
              <div class="col-12 col-md-12">
                <h1 class="title-price-section">Mobile app</h1>
              </div>
              <div class="col-12 col-md-12">
                <t class="from-sign">From&nbsp;&nbsp;</t><t class="dollar-sign">$</t><t class="price-number">&nbsp;3,000</t>
              </div>
              <div class="col-12 hidden-md">
                <button class="quote-button" v-on:click='data_to_app'>Request a plan</button>
              </div>
              <div class="hidden-xs col-md-12">
                <button class="quote-button" v-on:click='data_to_app_web'>Request a plan</button>
              </div>
            </div>
            <div class="row ligne-tick">
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;IOS 11 
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Android 8.0
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;UI / IX Interface
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Apple & Play stores 
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Analytics 
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Admin dashboards 
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Real-time Database
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;User Connection
              </div>
              <div class="col-12 col-md-10 collone-tick">
                <img :src="tick" style="width:20px;">&nbsp;&nbsp;&nbsp;Complex features
              </div>
            </div>
          </div>
        </div>
        <div class="hidden-xs col-md-1"></div>

    </div>
    <div  style="position:absolute;bottom:10;top:160px;width:100%;">
        <img :src="wave" style="width:100vw;">
    </div>
    <div class="hidden-md"  style="position:absolute;bottom:10;top:700px;width:100%;">
        <img :src="wave" style="width:100vw;">
    </div>
    <div class="hidden-md" style="position:absolute;bottom:10;top:1200px;width:100%;">
        <img :src="wave" style="width:100vw;">
    </div>   
</div>
</template>

<script scoped>

export default {
data() {
  return {
    msg: "Hello World!",
    isShowMyModal: false,
    wave: require('./assets/img/app/wave.svg'),
    mobile_app: require('./assets/img/app/mobile-app.svg'),
    show_contact_form: this.$parent.show_contact_form,
    tick: require('./assets/img/price/tick.svg')
  }
  },
    methods: {
      data_to_app: function data_to_app() {
        this.$emit('openContact');
      },
      data_to_app_web: function data_to_app_web() {
        this.$emit('openContactWeb');

      }
  }
}
</script>
<style scoped>
.collone-tick{
  padding-left:20%;
  margin-top:10px;
}

.ligne-tick{
  width:100%;margin-left:0px;padding-top:30px;
  text-align:left;
}

.quote-button{
/* Rectangle 27: */
background-image: linear-gradient(-180deg, #1E6297 0%, #194C6E 100%);
  border-radius:5px;
  margin-top:10px;
  height: 35px;
  width:150px;
  color:white;

}
.quote-button:hover{
  cursor: pointer;
/* Rectangle 27: */
background-image: linear-gradient(-180deg, rgb(51, 122, 177) 0%, rgb(42, 95, 131) 100%);

}

.price-number{
 font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:32px;

font-weight:normal; 
  
}

.dollar-sign{
font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:12px;
position:absolute;
font-weight:normal; 
padding-bottom:30px;  
}

.from-sign{
font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:18px;
font-weight:normal;  
}

.title-price-section{
font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:rgb(243, 224, 53);
font-size:24px;
font-weight:semi-bold; 
padding-top:20px;

}

.price-section{
  width:100%;
  height: 130px;
  margin-left:0px;
/* Rectangle 6: */
background-image: linear-gradient(-180deg, #32ACDD 0%, #3499DB 100%);
  border-top-left-radius:4px;
  border-top-right-radius:4px;
  position:relative;

}

/* mobile screen */
@media only screen and (max-width:70em) { 
.hidden-xs{
  display:none;
}
.landin-1-api{
  height:2320px;
  position:relative;
/* Rectangle 6: */
background-image: linear-gradient(-180deg, #1FD79E 0%, #077A55 100%);
  padding-top:100px;
  width:100%;
}
.card-price{
  width:96%;
  height: 490px;
/* Rectangle 11: */
background: rgba(255,255,255,0.77);
  border-radius:5px;
  position: center;
  margin-top:35px;
}
}

/* big screen */
@media only screen and (min-width:70em) { 
.hidden-md{
  display:none;
}
.text-landing-1{
    padding-top:0px;
    text-align:center;
}
.landin-1-api{
  height:780px;
  position:relative;
/* gradient: */
background-image: linear-gradient(-135deg, #622774 0%, #C53364 100%);
  padding-top:100px;
  width:100%;
}
.card-price{
  width:96%;
  height: 490px;
/* Rectangle 11: */
background: rgba(255,255,255,0.77);
  border-radius:5px;
  position: center;
  margin-top:15px;
}
}



.card-price:hover{
/* Rectangle 11: */
box-shadow: 0 2px 7px 2px rgba(0,0,0,0.19);
}

.title-landing{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:34px;
font-weight:normal;
}


.landin-2-website{
  height:750px;
 background-color:white;
  width:100%;
  padding-top:800px;
}


</style>


// WEBPACK FOOTER //
// src/price.vue